export default "__VITE_ASSET__DwkXVNlq__"